import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesServicesRouting } from './pages-services-routing.module';
import { AccessDeniedComponent } from './access-denied/access-denied.component';

@NgModule({
  declarations: [AccessDeniedComponent],
  imports: [CommonModule, PagesServicesRouting],
  exports: [AccessDeniedComponent],
})
export class PagesServicesModule {}
